import createSvgIcon from "./utils/create_icon"

const ChevronLeftLarge = createSvgIcon(<path clipRule="evenodd" d="M16.707 3.293a1 1 0 0 0-1.414 0l-8 8a1 1 0 0 0 0 1.414l8 8a1 1 0 0 0 1.414-1.414L9.414 12l7.293-7.293a1 1 0 0 0 0-1.414z" fill="currentColor" fillRule="evenodd" />, "ChevronLeftLarge")
export default ChevronLeftLarge
